import { Col, Container, Row } from "react-bootstrap";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import BasicTable from "../Atomics/Table";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import DatePicker from "react-multi-date-picker";
import { useContext, useState } from "react";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import LoadingIndicator from "../Atomics/Loading/Loading";
import ThinFooter from "../Footer/ThinFooter";
import { commentsFetcher, pannelInfoFetcher } from "../../api/requests";
import StackedBarChart from "../Atomics/StackBarChart";
import { AuthContext } from "../../context/auth";

const InteractionStatistics = () => {
  const [fromDate, setFromDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa }).subtract(7, "day")
  );
  const [toDate, setToDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa }).add(1, "day")
  );
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const { user } = useContext(AuthContext);

  const handleDateRangeFilter = () => {
    getFilteredData();
  };

  const convertToEnglishDigits = (persianDate) => {
    if (!persianDate) return null;

    return persianDate.replace(/[۰-۹]/g, (digit) =>
      "۰۱۲۳۴۵۶۷۸۹".indexOf(digit)
    );
  };

  const getFilteredData = async () => {
    setLoading(true);
    try {
      const res = await pannelInfoFetcher.getInteractions(
        convertToEnglishDigits(fromDate.format("YYYY-MM-DD")),
        convertToEnglishDigits(toDate.format("YYYY-MM-DD")),
        user.user_id
      );

      const processedData = res.map((item) => ({
        combinedKey: `${item.channel.name} - ${item.title} - ${
          item.ownership === "owner channel" ? "مالک کانال" : "ادمین کانال"
        }`,
        videoId: item.id,
        channelId: item.channel.id,
        channelName: item.channel.name,
        title: item.title,
        countedLike: item.counted_like,
        countedDislike: item.counted_dislike,
        countedShare: item.counted_share,
        countedSave: item.counted_save,
      }));

      setFilteredData(processedData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper heading="گزارش گیری واکنش ها" />
              </div>
            </Col>
          </Row>

          <Row className="p-3" style={{ gap: "8px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>از</span>
              <DatePicker
                value={fromDate}
                onChange={setFromDate}
                calendar={persian}
                locale={persian_fa}
                placeholder="تاریخ شروع"
                className="teal"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "8px",
                  width: "100%",
                }}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>تا</span>
              <DatePicker
                value={toDate}
                onChange={setToDate}
                calendar={persian}
                locale={persian_fa}
                placeholder="تاریخ پایان"
                className="teal"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "8px",
                  width: "100%",
                }}
              />
            </div>

            <div>
              <button
                className="btn btn-primary py-0"
                onClick={handleDateRangeFilter}
                style={{ width: "100%", fontSize: "14px" }}
              >
                فیلتر
              </button>
            </div>
          </Row>

          <Row className="py-3">
            <Col>
              {loading ? (
                <LoadingIndicator />
              ) : filteredData.length > 0 ? (
                <>
                  <StackedBarChart
                    data={filteredData}
                    keys={[
                      "countedLike",
                      "countedDislike",
                      "countedSave",
                      "countedShare",
                    ]}
                    colors={[
                      "#CDB4DB",
                      "#77DD77",
                      "#FF6961",
                      "#FFB347",
                      "#89CFF0",
                      "#FFD700",
                      "#FF9AA2",
                    ]}
                    xAxisKey="combinedKey"
                    height={400}
                  />
                  <br />
                  <BasicTable
                    name="interactionStatistics"
                    cols={[
                      "نام کانال",
                      "نام ویدئو",
                      "تعداد لایک",
                      "تعداد دیسلایک",
                      "تعداد اشتراک",
                      "تعداد ذخیره",
                    ]}
                    rows={filteredData}
                  />
                </>
              ) : (
                <p>داده ای در این تاریخ وارد نشده است.</p>
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default InteractionStatistics;
